import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { apiGet, apiPost } from './restUtil.service';

interface IProps {
    fetchUserProfile: Function;
}

function Header(props: IProps) {
    const { fetchUserProfile } = props;
    const handleLogout = async () => {
        try {
            await apiGet("/admin/log-out"); // Assuming no body is required
            // Call the parent-provided logout handler
            fetchUserProfile();
        } catch (error) {
            console.error("Error during logout:", error);
        }
    };

    return (
        <Navbar expand="lg" className="bg-body-tertiary">
            <Container>
                <Navbar.Brand href="#home">Answers AI</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/home">Home</Nav.Link>
                        <Nav.Link href="/feedback">Feedbacks</Nav.Link>
                        <Nav.Link onClick={handleLogout}>Log Out</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;